import type { ComponentType } from "react"

export interface BrandIconEntry {
  slug: string
  nama: string
  Icon: ComponentType<{ className?: string; color?: string }>
}

let modulCache: Record<string, ComponentType<{ className?: string; color?: string }>> | null = null
let entriCache: BrandIconEntry[] | null = null

function namaDariKey(key: string): string {
  return key
    .slice(2)
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .trim()
}

async function muatModul() {
  if (!modulCache || !entriCache) {
    const modul = await import("react-icons/si")
    modulCache = modul as unknown as Record<string, ComponentType<{ className?: string; color?: string }>>
    entriCache = Object.keys(modulCache)
      .filter((key) => key.startsWith("Si") && key.length > 2)
      .map((key) => ({
        slug: key.slice(2).toLowerCase(),
        nama: namaDariKey(key),
        Icon: modulCache![key],
      }))
  }
  return entriCache
}

function normalisasi(teks: string): string {
  return teks.trim().toLowerCase().replace(/[^a-z0-9]/g, "")
}

export async function cariIconBrand(slug: string): Promise<ComponentType<{ className?: string; color?: string }> | null> {
  const daftar = await muatModul()
  const target = normalisasi(slug)
  return daftar.find((e) => e.slug === target)?.Icon ?? null
}

export async function cariDaftarIconBrand(pencarian: string, maksimal = 60): Promise<BrandIconEntry[]> {
  const daftar = await muatModul()
  const q = normalisasi(pencarian)
  const hasil = q ? daftar.filter((e) => e.slug.includes(q)) : daftar.slice(0, maksimal)
  return hasil.slice(0, maksimal)
}
